@if (dialog.open()) {
  <div
    class="fixed inset-0 bg-ink/40 z-50 flex items-center justify-center p-4"
    data-overlay="true"
    (click)="onOverlayClick($event)"
  >
    <div class="bg-white rounded-lg border border-border shadow-lg w-full max-w-sm" role="dialog" aria-modal="true">

      <!-- Header -->
      <div class="flex items-start justify-between p-5 pb-0">
        <div class="flex items-center gap-3">
          <div class="w-9 h-9 rounded-full bg-[#FDE8E9] flex items-center justify-center shrink-0">
            <i class="pi pi-wallet text-danger text-base"></i>
          </div>
          <h2 class="text-[15px] font-semibold text-ink leading-[1.3]">{{ 'creditosDialog.titulo' | translate }}</h2>
        </div>
        <button
          type="button"
          (click)="close()"
          class="w-7 h-7 flex items-center justify-center rounded-md text-muted hover:text-ink hover:bg-surface transition-colors duration-[160ms] shrink-0 ml-2"
          [attr.aria-label]="'common.close' | translate"
        >
          <i class="pi pi-times text-sm"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="px-5 py-4 flex flex-col gap-3">
        @if (faltam(); as falta) {
          <!-- Custo conhecido: diz exatamente o tamanho do problema. -->
          <p class="text-sm text-ink leading-[1.6]">
            {{ 'creditosDialog.descFaltam.antes' | translate }}
            <span class="font-semibold">{{ falta | number }} {{ 'saldo.creditos' | translate }}</span>
            {{ 'creditosDialog.descFaltam.depois' | translate }}
          </p>
        } @else {
          <p class="text-sm text-ink leading-[1.6]">{{ 'creditosDialog.desc' | translate }}</p>
        }

        <div class="flex items-center justify-between text-[13px] px-3 py-2 rounded-md bg-surface border border-border">
          <span class="text-muted">{{ 'creditosDialog.saldoAtual' | translate }}</span>
          <span class="font-semibold text-ink tabular-nums">{{ saldo() | number }} {{ 'saldo.creditos' | translate }}</span>
        </div>

        @if (carregando()) {
          <app-loader [label]="'creditosDialog.carregando' | translate" size="md" />
        }

        @if (erroCompra(); as erro) {
          <p class="break-words text-[13px] text-danger leading-[1.5]">{{ erro }}</p>
        }
      </div>

      <!-- Footer -->
      <div class="px-5 pb-5 flex flex-col gap-2">
        @if (recomendado(); as pacote) {
          <!-- Compra em 1 clique do menor pacote que resolve o que falta. -->
          <button
            type="button"
            (click)="comprarRecomendado()"
            [disabled]="comprando()"
            [class]="'w-full h-11 rounded-[10px] text-white font-semibold text-sm transition-colors duration-[160ms] flex items-center justify-center gap-2 ' + (comprando() ? 'bg-primary-500 opacity-60 cursor-not-allowed' : 'bg-primary-500 hover:bg-primary-600 active:bg-primary-700')"
          >
            @if (comprando()) {
              <app-loader inline size="sm" [label]="'creditosDialog.processando' | translate" />
            } @else {
              <span>{{ 'creditosDialog.comprarAgora' | translate }} {{ pacote.creditoToken | number }} {{ 'saldo.creditos' | translate }}</span>
              <span class="opacity-80">· {{ formatBRL(pacote.valor) }}</span>
            }
          </button>
          <p class="text-[11px] text-muted text-center leading-[1.4]">{{ 'creditosDialog.avulsoNaoExpira' | translate }}</p>
        }

        <button
          type="button"
          (click)="verPacotes()"
          class="w-full h-10 rounded-[10px] border border-border bg-white hover:bg-surface text-ink font-semibold text-sm transition-colors duration-[160ms] flex items-center justify-center"
        >
          {{ 'creditosDialog.verTodosPacotes' | translate }}
        </button>
        <button
          type="button"
          (click)="aumentarPlano()"
          class="w-full h-9 rounded-[10px] text-muted hover:text-ink hover:bg-surface font-semibold text-[13px] transition-colors duration-[160ms] flex items-center justify-center"
        >
          {{ 'creditosDialog.aumentarPlano' | translate }}
        </button>
      </div>

    </div>
  </div>
}
